import NewLeaveLog from './NewLeaveLog';

export default NewLeaveLog;
